import { Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { SearchStateService } from './search-state.service';
import { HttpClient } from '@angular/common/http';
import { of, Observable, catchError } from 'rxjs';

@Injectable()
export class RoomBookingService {
  public loading: boolean;

  constructor(
    private http: HttpClient,
    private searchStateService: SearchStateService,
    private analyticsService: AnalyticsService,
  ) {}

  public bookRate(rate, hotelAvailabilityInfo, startTicket = null): Observable<any> {
    this.loading = true;
    let paramsToSet =
      'PAY_AT_DESTINATION' === rate.payment_method.code
        ? '?product=hotel&user_interaction=true&method=prepaid'
        : '?product=hotel&user_interaction=true';
    const paramsCurrentUrl = this.searchStateService.getParamsCurrentURL();
    const amReferrer = paramsCurrentUrl.am_referrer;
    const brand = paramsCurrentUrl.brand;
    const currencyCode = rate.price.currency.code;
    if (amReferrer) {
      paramsToSet += '&am_referrer=' + encodeURIComponent(amReferrer);
    }
    if (brand) {
      paramsToSet += '&brand=' + brand;
    }
    if (currencyCode) {
      paramsToSet += '&currencyCode=' + currencyCode;
    }
    const endpoint = '/chkabrouter/v2/cart' + paramsToSet;
    const params = {
      products: [
        {
          id: rate.id,
          type: 'HOTEL',
        },
      ],
      origin_product: 'HOTEL',
      currency_code: currencyCode,
      currencies_allowed: rate.currencies_allowed
    };

    const cart = {
      currencyCode: rate.price.currency.code,
      cityId: hotelAvailabilityInfo.city.id,
      hotelId: hotelAvailabilityInfo.id,
      hotelName: hotelAvailabilityInfo.name,
      priceTotal: rate.price.total,
      mealplanCode: rate.meal_plan.code,
      label: hotelAvailabilityInfo.isHomestay ? 'Alquiler temporario' : 'Hotel',
    };

    if (startTicket !== null) {
      cart['startTicket'] = startTicket;
    }
    this.analyticsService.addToCart(cart);
    // ToDo: Revisar este evento
    // this.analyticsService.newAddToCart({ ...rate, ...hotelAvailabilityInfo });
    this.loading = false;
    return this.http.post(endpoint, params).pipe(catchError(() => of(true)));
  }
}
